<template>
  <div>
    <v-row no-gutters class="mx-2 mt-2 justify-space-between">
      <v-col cols="4" class="d-flex align-center justify-center">
        <v-btn class="third white--text" @click="openDialog"> {{ dateStr }}</v-btn>
        <v-dialog v-model="dialog" class="pa-0" width="290">
          <v-card class="d-flex flex-column align-end pa-0">
            <v-card-text class="d-flex justify-center pa-0">
              <v-date-picker
                v-model="picker"
                :show-week="true"
                :first-day-of-week="1"
                color="third"
              />
            </v-card-text>
            <v-card-actions class="flex-grow-1 justify-end">
              <v-btn class="third--text" text @click="closeDialog">Cancel</v-btn>
              <v-btn class="third--text" text @click="pickDate">Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="4">
        <v-select
          v-model="selectedProduct"
          label="Produit"
          :items="products"
          item-value="uuid"
          item-text="name"
          color="third"
          return-object
          :loading="loading"
          @change="selectProduct"
        />
      </v-col>
    </v-row>
    <v-row no-gutters class="px-2">
      <v-data-table
        :headers="headers"
        :items="sessions"
      >
        <template #item.actions="{ item }">
          <v-icon @click="redirectAndShow(item.session.id, item.session.start_time)">mdi-information-variant-circle</v-icon>
        </template>
      </v-data-table>
    </v-row>
  </div>
</template>

<script>
import { ref, computed, onBeforeMount } from '@vue/composition-api';
import { endOfWeek, format, fromUnixTime, getUnixTime, startOfWeek, getISOWeek } from 'date-fns';
import { fr } from 'date-fns/esm/locale';
import store from '@/store';
import { getSessionByContentUuid } from '@/helpers/amplify';
import { sortArray } from '@/helpers/utils';

export default {
  setup () {
    const headers = ref([
      { text: 'Produit compatible', value: 'product', align: 'center', sortable: false, width: '15%' },
      { text: 'Nom de la session', value: 'session_name', align: 'center', sortable: false, width: '15%' },
      { text: 'Date de la session', value: 'date', align: 'center', sortable: false, width: '15%' },
      { text: 'Horaire de la session', value: 'hours', align: 'center', sortable: false, width: '15%' },
      { text: 'Nb min requis', value: 'minParticipants', align: 'center', sortable: false, width: '10%' },
      { text: 'NB Max requis', value: 'maxParticipants', align: 'center', sortable: false, width: '10%' },
      { text: 'Nombre de cavalier inscrit', value: 'participantsAmount', align: 'center', sortable: false, width: '10%' },
      { text: 'Détails de la session', value: 'actions', align: 'center', sortable: false, width: '10%' }
    ]);

    const selectedProduct = ref(null);
    const loading = ref(false);
    const dialog = ref(false);
    const picker = ref(format(new Date(), 'yyyy-MM-dd'));
    const selectedDate = ref(picker.value);
    const sessions = ref([]);

    const products = computed(() => store.state.products);

    const dateStr = computed(() => {
      const startWeek = format(startOfWeek(new Date(selectedDate.value), { weekStartsOn: 1 }), 'dd/MM/yyyy');
      const endWeek = format(endOfWeek(new Date(selectedDate.value), { weekStartsOn: 1 }), 'dd/MM/yyyy');
      const week = getISOWeek(new Date(selectedDate.value));
      return `[${week}] ${startWeek} - ${endWeek}`;
    });

    const prepareTableItems = allSessions => allSessions.map(session => ({
      product: selectedProduct.value.name,
      session_name: session.name,
      date: format(new Date(fromUnixTime(session.start_time)), 'dd-MM-yyyy (EEEE)', { locale: fr }),
      hours: `Du ${format(new Date(fromUnixTime(session.start_time)), 'HH:mm')} au ${format(new Date(fromUnixTime(session.end_time)), 'HH:mm')}`,
      minParticipants: session.min_participant || 0,
      maxParticipants: session.max_participant || '--',
      participantsAmount: (session.participants || []).length,
      session
    }));

    const selectProduct = async () => {
      if (selectedProduct.value) {
        const start = getUnixTime(startOfWeek(new Date(selectedDate.value), { weekStartsOn: 1 }));
        const end = getUnixTime(endOfWeek(new Date(selectedDate.value), { weekStartsOn: 1 }));
        loading.value = true;
        const allSessions = await getSessionByContentUuid('product', selectedProduct.value.uuid, store.getters.amplifyWorkspace, start, end);
        loading.value = false;

        sessions.value = prepareTableItems(sortArray(allSessions, 'start_time'));
      }
    };

    const redirectAndShow = (sessionId, sessionStartTime) => {
      window.open(`/?id=${sessionId}&startTime=${sessionStartTime}`, '_blank');
    };

    const pickDate = () => {
      selectedDate.value = picker.value;
      selectProduct();
      dialog.value = false;
    };

    const openDialog = () => {
      dialog.value = true;
    };

    const closeDialog = () => {
      dialog.value = false;
    };

    onBeforeMount(async () => {
      if (!store.state.isLazyLoaded.products) {
        loading.value = true;
        await store.dispatch('getProducts');
        loading.value = false;
      }
    });

    return { dateStr, openDialog, closeDialog, dialog, picker, pickDate, headers, selectedProduct, selectProduct, products, sessions, loading, redirectAndShow };
  }
};

</script>
